import React from 'react';
import { CategoryManager } from '@/components/dashboard/products/CategoryManager';
import { DashboardHead } from '@/components/SEO/DashboardHead';

export function CategoryManagementPage() {
  return (
    <div className="lg:p-4">
      <DashboardHead pageName="Categories" />
      <CategoryManager />
    </div>
  );
}
